import React from 'react';
import styled from 'styled-components';
import { isScopedReportsRole } from '../../utils/request';

const Notice = styled.div`
  background: #fff8e6;
  border: 1px solid #f0c75e;
  border-radius: 6px;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  font-size: 0.875rem;
  color: #6b5100;
`;

// Shown on tabs whose PDF/email/order totals are server-side role-scoped (see
// sof2_portal_backend's services/reports/reportScope.js) — explains why these numbers won't
// match what an ADMIN sees for the same date range, to head off support questions.
const ScopedDataNotice = () => {
  if (!isScopedReportsRole()) return null;
  return (
    <Notice>
      ℹ️ Totals on this page are limited to orders you have access to, plus PDFs and emails tied
      to those orders — emails with no associated order (e.g. system notifications) are excluded.
      These numbers will be lower than what an administrator sees for the same dates.
    </Notice>
  );
};

export default ScopedDataNotice;
